<template>
  <div>
    <a-modal
      :title="$t('page_business_spot_check')"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <ml-table
        :columns="columns"
        :dataSource="dataList"
        :pagination="pagination"
        :canChangeColWidth="true"
        rowKey="checkProjectId"
        :scroll="{ y: tableScrollY }"
        :selectRowKey="deviceId"
        :custom-row="rowClick"
      >
      </ml-table>
      <ml-table
        :columns="columnsform"
        :dataSource="dataChildren"
        :canChangeColWidth="true"
        :pagination="paginationForm"
        :scroll="{ y: tableScrollY }"
      >
      </ml-table>
    </a-modal>
  </div>
</template>

<script>
import {
  DeviceTypeCheckProjectServiceProxy,
  CheckItemServiceProxy,
} from "@/service-proxies/app-v2/tpm.service-proxies";
const deviceTypeCheckProjectServiceProxy = new DeviceTypeCheckProjectServiceProxy();
const checkItemServiceProxy = new CheckItemServiceProxy();
// const columns = [
//   { title: "点检编码", dataIndex: "code", width: 150, ellipsis: true },
//   { title: "点检项目", dataIndex: "name", width: 200, ellipsis: true },
//   { title: "点检周期", dataIndex: "intervalTime", width: 100, ellipsis: true },
//   { title: "备注", dataIndex: "remark", ellipsis: true },
// ];
// const columnsform = [
//   { title: "点检项", dataIndex: "name", ellipsis: true, width: 200 },
//   { title: "数值类型", dataIndex: "valueType", ellipsis: true, width: 150 },
//   { title: "点检要求", dataIndex: "requirement", ellipsis: true, width: 150 },
//   { title: "标准数值", dataIndex: "standardValue", ellipsis: true },
// ];
export default {
  props: ["typeList", "typeId", "visible", "spotCheckId"],
  data() {
    return {
      confirmLoading: false,
      // columns,
      // columnsform,
      dataList: [],
      tableScrollY: 300,
      selectedRowKeys: [],
      dataChildren: [],
      deviceId: "",
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },
      paginationForm: {
        total: 0,
        pageSize: 10,
        current: 1,
      },
    };
  },
  created() {
    this.pagination.onChange = (currentPage) => {
      this.pagination.current = currentPage;
      this.getDeviceTypeCheckProjectPage();
    };
    this.paginationForm.onChange = (currentPage) => {
      this.paginationForm.current = currentPage;
      this.pageCheckItems();
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("page_device_spotcheck_code"),
          dataIndex: "code",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_business_spot_check"),
          dataIndex: "name",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_device_spotcheck_cycle"),
          dataIndex: "intervalTime",
          width: 100,
          ellipsis: true,
        },
        { title: this.$t("remark"), 
          dataIndex: "remark", 
          ellipsis: true,
          width: 100, 
        },
      ];
    },
    columnsform() {
      return [
        {
          title: this.$t("page_device_spotcheck_items"),
          dataIndex: "name",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_device_spotcheck_value_type"),
          dataIndex: "valueType",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_device_spotcheck_requirement"),
          dataIndex: "requirement",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_device_spotcheck_standard_value"),
          dataIndex: "standardValue",
          ellipsis: true,
          width: 100,
        },
      ];
    },
  },
  watch: {
    visible(val) {
      if (val && this.spotCheckId) {
        this.getDeviceTypeCheckProjectPage();
        console.log("pppppppppp", this.spotCheckId);
      }
    },
    selectedRowKeys(val) {
      if (val) {
        this.pageCheckItems();
      }
    },
  },
  methods: {
    // onSelectChange(selectedRowKeys, selectedRows) {
    //   this.selectedRowKeys = selectedRowKeys;
    //   // console.log(selectedRowKeys)
    // },
    handleOk(e) {
      this.confirmLoading = true;
      setTimeout(() => {
        this.$emit("closeSpotCheck");
        this.confirmLoading = false;
      }, 2000);
    },
    handleCancel(e) {
      // console.log("Clicked cancel button");
      this.$emit("closeSpotCheck");
    },
    async getDeviceTypeCheckProjectPage() {
      let result = await deviceTypeCheckProjectServiceProxy.getDeviceTypeCheckProjectPage(
        this.pagination.current,
        this.spotCheckId,
        this.pagination.pageSize
      );
      this.dataList = result.records;
      this.pagination.total = result.total;
      console.log("asda:", this.dataList);
      this.selectedRowKeys = [];
      if (this.dataList.length) {
        this.selectedRowKeys.push(this.dataList[0].checkProjectId);
        this.deviceId = this.dataList[0].checkProjectId;
      }
    },
    async pageCheckItems() {
      let result = await checkItemServiceProxy.pageCheckItems(
        this.paginationForm.current,
        this.selectedRowKeys,
        this.paginationForm.pageSize
      );
      this.dataChildren = result.records;
      this.paginationForm.total = result.total;
      // console.log("daffsdfads:",this.dataChildren)
    },

    rowClick(record) {
      return {
        on: {
          click: (event) => {
            // console.log("aaaaaa", record);
            this.deviceId = record.checkProjectId;
            this.selectedRowKeys = [];
            this.selectedRowKeys.push(record.checkProjectId);
          },
        },
      };
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-modal {
  width: 1240px !important;
}
</style>
